<script>
  import Container from "./Component/Container.svelte";
  import { initClient } from "@urql/svelte";
  import { url } from "./Api/config";

  export let type = "news";
  export let categoryId;
  export let location;
  export let offset;
  export let ignoredCategories = [];

  export let limit = 20;
  export let showCategories;
  export let narrowImages;
  export let more;
  export let headline;

  initClient({
    url: `${url}/api/editorialcontent`,
  });
</script>

<Container {categoryId} {location} {offset} {limit} {headline} {showCategories} {narrowImages} {more} {type} {ignoredCategories} />
